import AutoNumeric from 'autonumeric';

jQuery(document).ready(function ($) {
  var AutonumericRails;

  window.AutonumericRails = AutonumericRails = (function () {
    AutonumericRails.create_autonumeric_object = function (obj) {
      if (!obj.data('autonumeric-initialized')) {
        return new this(obj);
      }
    };

    AutonumericRails.delete_autonumeric_object = function (obj) {
      if (obj.data('autonumeric-initialized')) {
        obj.removeData('autonumeric-initialized').removeData('autonumeric').removeAttr('data-autonumeric').off('keyup blur').remove();
        $('input#' + obj.attr('id') + '_val[type="hidden"][name="' + obj.attr('name') + '"]').remove();
      }
    };

    function AutonumericRails(field) {
      this.field = field;
      this.myAutoNumeric = '';
      this.field.data('autonumeric-initialized', true);
      this.create_hidden_field();
      this.init_autonumeric(field.get(0));
      this.sanitize_value();
      this.field.on('keyup blur keydown keypress', $.proxy(function () {
        this.sanitize_value();
      }, this));
    }

    AutonumericRails.prototype.create_hidden_field = function () {
      this.hidden = $('<input>').attr('type', 'hidden').attr('id', this.field.attr('id') + '_val').attr('name', this.field.attr('name'));
      this.hidden.insertAfter(this.field);
    };

    AutonumericRails.prototype.init_autonumeric = function (field) {
      this.myAutoNumeric = new AutoNumeric(field, $.parseJSON($(field).attr('data-autonumeric')));
    };

    AutonumericRails.prototype.sanitize_value = function () {
      this.myAutoNumeric.reformat();
      this.hidden.val(this.myAutoNumeric.rawValue);
    };

    return AutonumericRails;

  })();

  window.refresh_autonumeric = function () {
    $('input[data-autonumeric]').each(function () {
      AutonumericRails.create_autonumeric_object($(this));
    });
  };

  jQuery(function () {
    window.refresh_autonumeric();
    $(document).on('refresh_autonumeric', function () {
      window.refresh_autonumeric();
    });
    $(document).on('ajaxComplete', function () {
      window.refresh_autonumeric();
    });
  });
})


// WEBPACK FOOTER //
// ./app/webpacker/src/js/numeric_inputs.js